import { useEffect, useState } from "react";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import moment from "moment";

const WrappedKeyboardDateTimePicker = ({
  InputLabelProps,
  dataCy,
  id,
  clearable,
  showTodayButton,
  label,
  onFocus,
  onBlur,
  value,
  onChange,
  format,
  ampm,
  disabled,
  confirmFutureDate = false,
  className = null,
  name = "callTime",
  disableFuture = false,
  maxDateMessage = "Date is out of range",
  autoFocus = false,
  onDoubleClick,
  onKeyDown,
}) => {
  const [localState, setLocalState] = useState(
    value ? moment.utc(value, "YYYY-MM-DD HH:mm:ss UTC").local() : null,
  );

  useEffect(() => {
    setLocalState(
      value ? moment.utc(value, "YYYY-MM-DD HH:mm:ss UTC").local() : null,
    );
  }, [value]);

  const handleChange = (newValue, str, date) => {
    setLocalState(newValue);
    onChange(newValue, str, date);
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-autofocus -- Preserve focus requested by forms when the date field needs attention.
    <KeyboardDateTimePicker autoFocus={autoFocus}
      InputLabelProps={{ ...{ shrink: true }, ...InputLabelProps }}
      data-cy={dataCy}
      id={id}
      clearable={clearable || true}
      showTodayButton={showTodayButton || false}
      label={label}
      onFocus={() => !!onFocus && onFocus(true)}
      onBlur={() => !!onBlur && onBlur(false)}
      value={localState}
      onChange={(date, value) => {
        if (confirmFutureDate && date?.isAfter(moment())) {
          if (
            window.confirm(
              "The date and time you have selected is in the future. The incident will not display on the dashboard until the selected time is reached. Do you wish to continue?",
            )
          ) {
            handleChange(value, name, date);
          } else {
            return;
          }
        } else {
          handleChange(value, name, date);
        }
      }}
      format={format || "MM/DD/YYYY HH:mm"}
      ampm={ampm || false}
      disabled={disabled}
      className={className}
      disableFuture={disableFuture}
      maxDateMessage={maxDateMessage}
      onDoubleClick={() => !disabled && !!onDoubleClick && onDoubleClick()}
      onKeyDown={event => {
        if (onKeyDown) {
          onKeyDown(event);
        }
      }}
    />
  );
};

export default WrappedKeyboardDateTimePicker;
